import { Box, CircularProgress } from '@alice-financial/pretext-ui'
import * as React from 'react'

type WalletButtonLoadingStateProps = {
  /** Whether to include bottom margin (for main card display) */
  withBottomMargin?: boolean
}

/**
 * Shared loading state component for the Apple Wallet button.
 * Shows a centered circular progress indicator while the Stripe button is being prepared.
 */
export const WalletButtonLoadingState = ({ withBottomMargin = false }: WalletButtonLoadingStateProps) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" mb={withBottomMargin ? 4 : 0}>
      <CircularProgress size={16} />
    </Box>
  )
}

